import React from "react";
import {connect} from "react-redux";

class ConfirmationPage extends React.Component {
  render() {
    return (
      <div>
        <div className="row mt-5">
          <div className="col-lg-12">
              <h1 className="display-2">Tack för att du beställer hemförsäkring hos Länsförsäkringar.</h1>
              <p className="mt-4">
              Du har köpt en hemförsäkring som börjar att gälla från och med {this.props.apartment_information.insurance_start}.<br />
              Har du frågor om försäkringen är du alltid välkommen att höra av dig på telefon 040-633 80 90.<br />
              Är det något som vi undrar över kontaktar vi dig. Annars har du försäkringsbrevet i brevlådan inom 14 dagar.
              </p>
              <p className="font-weight-bold mt-5 text-black mb-0">Vänliga hälsningar</p>
              <h2 className="display-4 mt-0">Länsförsäkringar Skåne</h2>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
    return {
      data: state,
      apartment_information: state.apartmentReducer.apartment_information,
      contact_information: state.contactReducer.contact_information,
      personal_terms_accepted: state.simpleReducer.personal_terms_accepted,
      consent_information_accepted: state.simpleReducer.consent_information_accepted,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage);
